import Vue from 'vue'
import Vuex from 'vuex'
import { getInfo } from '@/api/login'
Vue.use(Vuex)

const defaultCurrent = 'homePage'
export default new Vuex.Store({
  getters: {
    showBack: state => state.showBack,
    userName: state => state.userName,
    roles:state => state.roles,
  },
  state: {
    current: defaultCurrent,
    showBack: false,
    userName:null,
    roles:null
  },
  mutations: {
    routerItem(state, val) {
      state.current = val
      state.showBack = false
    },
    showBack(state, val) {
      state.showBack = val
    },
    SET_NAME(state,val){
      state.userName = val
    },
    SET_RULES(state,val){
      state.roles = val
    },
  },
  actions: {
    GetInfo( {
      commit,
      state
    } ) {
      return new Promise( ( resolve, reject ) => {
        getInfo().then( res => {
          console.log(44,res)
          commit( 'SET_NAME', res.user.nickName )
          commit( 'SET_RULES', res.user.roles )
          resolve( res )
        } ).catch( error => {
          reject( error )
        } )
      } )
    },
  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js